/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserData } from './UserData';
import {
    UserDataFromJSON,
    UserDataFromJSONTyped,
    UserDataToJSON,
    UserDataToJSONTyped,
} from './UserData';

/**
 * 
 * @export
 * @interface AuthenticatedResponse
 */
export interface AuthenticatedResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthenticatedResponse
     */
    token?: string;
    /**
     * 
     * @type {UserData}
     * @memberof AuthenticatedResponse
     */
    user?: UserData;
}

/**
 * Check if a given object implements the AuthenticatedResponse interface.
 */
export function instanceOfAuthenticatedResponse(value: object): value is AuthenticatedResponse {
    return true;
}

export function AuthenticatedResponseFromJSON(json: any): AuthenticatedResponse {
    return AuthenticatedResponseFromJSONTyped(json, false);
}

export function AuthenticatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticatedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'] == null ? undefined : json['token'],
        'user': json['user'] == null ? undefined : UserDataFromJSON(json['user']),
    };
}

export function AuthenticatedResponseToJSON(json: any): AuthenticatedResponse {
    return AuthenticatedResponseToJSONTyped(json, false);
}

export function AuthenticatedResponseToJSONTyped(value?: AuthenticatedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'user': UserDataToJSON(value['user']),
    };
}

